import { CaretDownOutlined } from '@ant-design/icons';
import { faFill, faPen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dropdown, Input, Menu, Tooltip } from 'antd';
import { clamp } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { images } from '../../appCore';
import { updateComponentSettings } from '../../redux/board/reducer';
import { setIsContentChange } from '../../redux/stateManager/reducer';
import { CUSTOM_GROUP_ID, DASH_ARRAY, eventBus, FABRIC_CUSTOM_OBJECT, GROUP, IMAGE, TEXT, TEXTBOX } from '../../utils';
import ColorPicker from '../ColorPicker';
import './styles.scss';

export default () => {
  const dispatch = useDispatch();
  const activeType = useSelector((state) => state.board.activeType);
  const componentSettings = useSelector((state) => state.board.componentSettings);
  const initialState = {
    opacity: 1,
    fill: '#fff',
    stroke: '#000',
    strokeWidth: 1,
    strokeDashArray: null,
  };
  const [state, _setState] = useState(initialState);
  const setState = (obj) => _setState((_state) => ({ ..._state, ...obj }));
  const shouldRender = () => {
    const activeObj = window.canvas.getActiveObject();
    if (!activeObj) return false;
    if ([IMAGE].includes(activeObj.type)) return false;

    if ([GROUP].includes(activeObj.type)) {
      const { id = '' } = activeObj;
      const groupHasOneObj = !id.includes(CUSTOM_GROUP_ID) && activeObj.getObjects().length === 1;
      if (groupHasOneObj || activeObj.colorSetting) {
        return true;
      }
      return false;
    }
    return true;
  };
  const isRenderRadius = () => {
    const activeObj = window.canvas.getActiveObject();
    const { id = '' } = activeObj;
    if (activeType === 'path') return false;
    if (id.includes(CUSTOM_GROUP_ID)) {
      return false;
    }
    return true;
  };

  const isRenderFill = () => {
    if (activeType === FABRIC_CUSTOM_OBJECT.polyline) return false;
    return true;
  };
  const isRenderStrokeDash = () => {
    const activeObj = window.canvas.getActiveObject();
    if (activeObj.type === 'Brackets') return false;
    return true;
  };
  const onChangeFill = (e, item) => {
    const value = ['opacity', 'fill'].includes(item) ? e : e.target.value;
    setState({ [item]: value });
    eventBus.emit('save-state-and-progress');
    dispatch(setIsContentChange(true));
    dispatch(updateComponentSettings({ ...state, [item]: value }));
  };
  const onChangeStroke = (e, item) => {
    const value = ['strokeWidth', 'stroke'].includes(item) ? e : e.target.value;
    setState({ [item]: value });
    eventBus.emit('save-state-and-progress');
    dispatch(setIsContentChange(true));
    dispatch(updateComponentSettings({ ...state, [item]: value }));
  };
  const onTextChange = (e) => {
    e.stopPropagation();
    let value = e.target.value.replace(/[^0-9]/g, '');
    eventBus.emit('save-state-and-progress');
    dispatch(setIsContentChange(true));
    value = clamp(value, activeType === FABRIC_CUSTOM_OBJECT.polyline ? 1 : 0, 50);
    setState({ strokeWidth: parseFloat(value) });
    dispatch(updateComponentSettings({ ...state, strokeWidth: parseFloat(value) }));
  };
  const onChangeRadius = (e) => {
    const radius = {
      rx: e.target.value || 0,
      ry: e.target.value || 0,
    };
    eventBus.emit('save-state-and-progress');
    dispatch(setIsContentChange(true));
    dispatch(updateComponentSettings({ ...state, ...radius }));
  };
  const handleLineStyleClick = (e) => {
    const newDashArray = DASH_ARRAY[Number(e.key)].strokeDashArray || [0];
    const newDashLineCap = DASH_ARRAY[Number(e.key)].strokeLineCap || 'butt';
    setState({ ['strokeDashArray']: newDashArray, ['strokeLineCap']: newDashLineCap });
    eventBus.emit('save-state-and-progress');
    dispatch(setIsContentChange(true));
    dispatch(updateComponentSettings({ ...state, strokeDashArray: newDashArray, strokeLineCap: newDashLineCap }));
  };
  const linePicker = (
    <Menu className="line-container" onClick={handleLineStyleClick}>
      {DASH_ARRAY.map((i, index) => (
        <Menu.Item key={index}>
          <div
            style={{
              borderColor:
                JSON.stringify(i.strokeDashArray) === JSON.stringify(state.strokeDashArray) ? '#4eccf5' : '#ccc',
            }}
            className="line-item"
          >
            <svg style={{ height: '20px', width: '68px' }}>
              <line
                x1="0"
                y1="10"
                x2="100%"
                y2="10"
                stroke="black"
                strokeDasharray={i.strokeDashArray?.toString().replace(',', ' ')}
                strokeLinecap={i.strokeLineCap}
              />
            </svg>
          </div>
        </Menu.Item>
      ))}
    </Menu>
  );
  useEffect(() => {
    if (componentSettings) {
      setState(componentSettings);
    }
  }, [componentSettings]);
  return activeType && activeType !== TEXT && activeType !== TEXTBOX && activeType !== IMAGE ? (
    <div className="mo__appearance-settings">
      {shouldRender() ? (
        <>
          {/* -------- Fill -------- */}
          {isRenderFill() && (
            <div className="setting-item">
              <span className="icon">
                <FontAwesomeIcon icon={faFill} style={{ fontSize: '16px' }} />
              </span>
              <Tooltip title="Background Color">
                <ColorPicker onChange={onChangeFill} type="fill" color={state.fill || '#fff'} place="settings" />
              </Tooltip>
            </div>
          )}
          {/* -------- Stroke -------- */}
          <div className="setting-item">
            <span className="icon">
              <FontAwesomeIcon icon={faPen} style={{ fontSize: '16px' }} />
            </span>
            <Tooltip title="Stroke Color">
              <ColorPicker onChange={onChangeStroke} type="stroke" color={state.stroke || '#000'} place="settings" />
            </Tooltip>
          </div>
          {/* -------- Stroke Dash -------- */}
          {isRenderStrokeDash() && (
            <div className="setting-item">
              <span className="icon">
                <img src={images.STROKE_DASH} alt="" style={{ width: '16px', height: '16px' }} />
              </span>
              <Tooltip title="Stroke Dash">
                <Dropdown overlay={linePicker} trigger={['click']}>
                  <Button type="primary" className="line-select">
                    <div>
                      <svg style={{ height: '20px', width: '160px' }}>
                        <line
                          x1="0"
                          y1="10"
                          x2="100%"
                          y2="10"
                          stroke="black"
                          strokeDasharray={state.strokeDashArray?.toString().replace(',', ' ')}
                          strokeLinecap={state.strokeLineCap}
                        />
                      </svg>
                      <CaretDownOutlined />
                    </div>
                  </Button>
                </Dropdown>
              </Tooltip>
            </div>
          )}
          <div className="setting-group">
            {/* -------- Thickness -------- */}
            <div className="setting-item">
              <span className="icon">
                <img src={images.STROKE} alt="" style={{ width: '16px' }} />
              </span>
              <Tooltip title="Stroke Width">
                <Input
                  className="custom-input"
                  title="Stroke Width"
                  type="number"
                  min={0}
                  value={state.strokeWidth || 0}
                  onSelect={(e) => {
                    e.stopPropagation();
                  }}
                  onChange={onTextChange}
                  onKeyDown={(e) => {
                    e.stopPropagation();
                  }}
                />
              </Tooltip>
            </div>
            {/* -------- Corner Radius -------- */}
            {isRenderRadius() && (
              <div className="setting-item">
                <span className="icon">
                  <img src={images.ROUNDER_CORNER} alt="" style={{ width: '16px' }} />
                </span>
                <Tooltip title="Corner Radius">
                  <Input
                    className="custom-input"
                    title="Corner Radius"
                    type="number"
                    min={0}
                    value={state.rx || state.ry || 0}
                    onChange={(e) => {
                      onChangeRadius(e);
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Tooltip>
              </div>
            )}
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  ) : (
    <div />
  );
};
